/**
 * Subscription Price Update
 * Updates the Add to Cart button price when subscription option is selected
 */

class SubscriptionPriceUpdater {
  constructor() {
    this.subscriptionOptions = document.querySelectorAll('input[name="subscription_option"]');
    this.submitButton = document.querySelector('.product-form__submit');
    this.submitPriceElement = document.querySelector('.product-form__submit-price');

    if (!this.subscriptionOptions.length || !this.submitButton || !this.submitPriceElement) {
      return;
    }

    this.init();
  }

  init() {
    // Get the original product price
    this.originalPrice = this.submitPriceElement.textContent;

    // Get subscription data
    this.getSubscriptionData();

    // Add event listeners to radio buttons
    this.subscriptionOptions.forEach(radio => {
      radio.addEventListener('change', this.handleSubscriptionChange.bind(this));
    });

    // Listen for variant changes
    this.setupVariantChangeListener();

    // Update visual state on page load
    this.updateVisualState();
  }

  setupVariantChangeListener() {
    // Listen for price changes in the submit button (triggered by variant changes)
    const observerConfig = { childList: true, subtree: true, characterData: true };

    this.priceObserver = new MutationObserver((mutations) => {
      // Only update if no subscription is selected (to preserve subscription price)
      const subscriptionTrue = document.getElementById('subscription_true');
      if (!subscriptionTrue || !subscriptionTrue.checked) {
        this.originalPrice = this.submitPriceElement.textContent;
      }
    });

    if (this.submitPriceElement) {
      this.priceObserver.observe(this.submitPriceElement, observerConfig);
    }
  }

  getSubscriptionData() {
    // Get the subscription price from the subscription upsell section
    const subscriptionPriceElement = document.querySelector('.subscription-sale-price');
    if (subscriptionPriceElement) {
      this.subscriptionPrice = subscriptionPriceElement.textContent;
    }
  }

  handleSubscriptionChange(event) {
    const subscriptionTrue = document.getElementById('subscription_true');

    if (subscriptionTrue && subscriptionTrue.checked) {
      // Subscription is selected - show subscription price
      if (this.subscriptionPrice) {
        this.submitPriceElement.textContent = this.subscriptionPrice;
      }
    } else {
      // No subscription - show original price
      this.submitPriceElement.textContent = this.originalPrice;
    }

    // Update visual state
    this.updateVisualState();
  }

  updateVisualState() {
    // Update the subscription option visual selection state
    const subscriptionFalse = document.getElementById('subscription_false');
    const subscriptionTrue = document.getElementById('subscription_true');

    const optionElements = document.querySelectorAll('.subscription-upsell__option');

    if (optionElements.length >= 2) {
      if (subscriptionFalse && subscriptionFalse.checked) {
        optionElements[0].classList.add('subscription-upsell__option--selected');
        optionElements[1].classList.remove('subscription-upsell__option--selected');
      } else if (subscriptionTrue && subscriptionTrue.checked) {
        optionElements[0].classList.remove('subscription-upsell__option--selected');
        optionElements[1].classList.add('subscription-upsell__option--selected');
      }
    }
  }

  disconnect() {
    // Clean up observer if needed
    if (this.priceObserver) {
      this.priceObserver.disconnect();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SubscriptionPriceUpdater();
  });
} else {
  new SubscriptionPriceUpdater();
}

